var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgReservation = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M21 14.59 22.41 16 16 22.41 12.59 19 14 17.59l2 2z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M23 2v10h-2V4H1v16h9v2H-1V2z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M7-1v5H5v-5zM17-1v5h-2v-5zM22 6v2H0V6z"
})));
export default SvgReservation;